/**
 * Unauthenticated fetch for public marketing pages.
 * Kept separate from `api.ts` so the marketing bundle does not load Supabase.
 */

import { apiBaseUrl } from './apiBase';

export class PublicApiError extends Error {
  constructor(message: string) {
    super(message);
  }
}

async function readBody(res: Response): Promise<unknown> {
  const text = await res.text();
  if (!text.trim()) return undefined;
  try {
    return JSON.parse(text) as unknown;
  } catch {
    return text;
  }
}

function messageFrom(body: unknown, fallback: string): string {
  if (body && typeof body === 'object' && 'message' in body) {
    const message = (body as { message: unknown }).message;
    if (typeof message === 'string' && message.trim()) return message;
  }
  return fallback;
}

export async function publicGet<T>(path: string): Promise<T> {
  const res = await fetch(`${apiBaseUrl()}${path}`, { credentials: 'include' });
  const body = await readBody(res);
  if (!res.ok) throw new PublicApiError(messageFrom(body, 'The request failed.'));
  return body as T;
}

export async function publicPost<T>(path: string, payload: unknown): Promise<T> {
  const res = await fetch(`${apiBaseUrl()}${path}`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const body = await readBody(res);
  if (!res.ok) {
    throw new PublicApiError(
      messageFrom(body, 'We could not send that just now. Please try again later.'),
    );
  }
  return body as T;
}
